@if (ourBrandsPage) {
  <app-image class="hero-img" [prismicImage]="ourBrandsPage.hero_image" [bcimage]="true"></app-image>
  <!-- <div class="d-flex logos w-100">
  <div class="logo-shift">
  </div>
  <div class="row gx-5">
    <div class="col-12 col-md-6 d-flex justify-content-center justify-content-md-end">
      <img class="brand-img" src="assets/images/logos/bioguard-logo.png" alt="BioGuard Logo">
    </div>
    <div class="col-12 col-md-6 d-flex justify-content-center justify-content-md-end">
      <img class="brand-img" src="assets/images/logos/poolife.png" alt="Poolife Logo">
    </div>
    <div class="col-12 col-md-6 d-flex justify-content-center justify-content-md-end">
      <img class="brand-img" src="assets/images/logos/frog-logo.png" alt="Spa Frog Logo">
    </div>
    <div class="col-12 col-md-6 d-flex justify-content-center justify-content-md-end">
      <img class="brand-img" src="assets/images/logos/SpaGuard-Logo.png" alt="SpaGuard Logo">
    </div>
  </div>
  <div class="row gx-5">
    <div class="col-12 col-md-6 d-flex justify-content-center justify-content-md-end">
      <img class="brand-img" src="assets/images/logos/leisure-time-logo.png" alt="Leisure Time Logo">
    </div>
    <div class="col-12 col-md-6 d-flex justify-content-center justify-content-md-end">
      <img class="brand-img" src="assets/images/logos/Freshwater-Salt-System-Logo.png" alt="Freshwater Salt System Logo">
    </div>
    <div class="col-12 col-md-6 d-flex justify-content-center justify-content-md-end">
      <img class="brand-img" src="assets/images/logos/Baquacil-Logo.png" alt="Baquacil Logo">
    </div>
    <div class="col-12 col-md-6 d-flex justify-content-center justify-content-md-end">
      <img class="brand-img" src="assets/images/logos/sirona-logo.png" alt="Sirona Logo">
    </div>
  </div>
</div> -->
<div class="d-flex flex-column">
  <div class="container">
    <div class="hero-title text-center text-md-start">
      <p class="title-secondary my-3">TOP RATED BRANDS</p>
      <h1>{{ourBrandsPage.title[0]?.text}}</h1>
      <div [innerHtml]="ourBrandsPage.hero_body"></div>
    </div>
  </div>
  <div class="mt-5 mt-xl-0">
    <img class="wave-right" src="assets/images/pink-curve-right.png" alt="pink wave pointing right">
  </div>
  <div class="container">
    @if (ourBrandsPage) {
      <div class="d-flex flex-column align-items-center justify-content-center my-5">
        <h2 class="mt-0 mt-xl-5">All Brands</h2>
        <div class="row g-0">
          @for (brand of ourBrandsPage?.brandsReel?.brands; track brand) {
            <div class="border col-6 col-md-4 col-lg-2">
              <app-brand-card [brand]="brand"></app-brand-card>
            </div>
          }
        </div>
      </div>
      <!-- <div class="my-5">
      <app-shop-by-brand [brandsReel]="ourBrandsPage.brandsReel"></app-shop-by-brand>
    </div> -->
  }
</div>
<div class="container">
  @if (ourBrandsPage) {
    <div class="d-flex flex-column align-items-center justify-content-center my-5">
      <h2 class="mt-0 mt-xl-5">{{ourBrandsPage.brands_info_title[0]?.text}}</h2>
      <div class="pt-3" [innerHtml]="ourBrandsPage.brands_info_body"></div>
    </div>
  }
</div>
<div class="mt-5 mt-xl-0">
  <img class="wave-left" src="assets/images/pink-curve-left.png" alt="pink wave pointing left">
</div>
<div class="container">
  @if (ourBrandsPage) {
    <div class="d-flex flex-column align-items-center justify-content-center my-5">
      <h2 class="mt-0 mt-xl-5">{{ourBrandsPage.subsection_title[0]?.text}}</h2>
      <div class="pt-3" [innerHtml]="ourBrandsPage.subsection_body"></div>
      <app-image class="info-image my-5" [prismicImage]="ourBrandsPage.subsection_image" [bcimage]="false"></app-image>
    </div>
  }
</div>
</div>
}
